<style src="./Button.scss" lang="scss"></style>

<script>
	export default {
		name: 'HpButton',
		props: ['type'],
		methods: {
			clicked($event) {
				this.$emit('click', $event);
			}
		}
	};
</script>

<template>
	<button data-component="button" type="submit" @click="clicked" v-if="type == 'submit'">
		<slot>Button</slot>
	</button>
	<a data-component="button" @click="clicked" v-else>
		<slot>Button</slot>
	</a>
</template>
